declare global {
  function gtag(type: string, name: string, data: any): any
}

export const logEvent = (name: string, data: any = {}) => {
  if (!globalThis.gtag) {
    return
  }

  globalThis.gtag("event", name, data)
}
